import React, { createContext, useContext } from 'react';

// Create the theme context
const ThemeContext = createContext({
  theme: 'dark',
  setTheme: () => {},
});

// Theme provider component
export const ThemeProvider = ({ children, value }) => {
  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme context
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;